module.exports = __webpack_public_path__ + "static/media/020.53bbef76.jpg";